/** Annual account revenue potential band (maps to API `AccountPotential`). */
export const OPPORTUNITY_ACCOUNT_POTENTIAL_VALUES = ['S', 'M', 'L'] as const;

export type OpportunityAccountPotential =
  (typeof OPPORTUNITY_ACCOUNT_POTENTIAL_VALUES)[number] | '';

/** Existing customer relationship strength (maps to API `ExistingRelationship`). */
export const OPPORTUNITY_EXISTING_RELATIONSHIP_VALUES = ['none', 'partial', 'strong'] as const;

export type OpportunityExistingRelationship =
  (typeof OPPORTUNITY_EXISTING_RELATIONSHIP_VALUES)[number] | '';

export const EXISTING_RELATIONSHIP_OPTIONS = [
  { value: 'none', label: 'None' },
  { value: 'partial', label: 'Partial' },
  { value: 'strong', label: 'Strong' },
] as const;

export const EXISTING_RELATIONSHIP_HINTS: Record<
  Exclude<OpportunityExistingRelationship, ''>,
  { subtitle: string; hint: string }
> = {
  none: {
    subtitle: 'No prior work',
    hint: 'No established relationship with this account',
  },
  partial: {
    subtitle: 'Some history',
    hint: 'Limited prior engagements or contacts',
  },
  strong: {
    subtitle: 'Established',
    hint: 'Proven delivery history with this account',
  },
};
